import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import {MenuItem, Select, useTheme} from "@mui/material";
import {useEffect, useState} from "react";

export default function FormSelect({
                                     data,
                                     elemId,
                                     label,
                                     className,
                                     value,
                                     onChange,
                                     inputProps,
                                     name,
                                     classes,
                                     maxContentLength,
                                     disabled
                                   }) {
  let [state, setState] = React.useState(value);
  let [values] = React.useState(data);

  const theme = useTheme();

  const handleChange = (event) => {
    onChange ? onChange(event) : void 0;

    setState(event.target.value);
  };

  if (maxContentLength)
    maxContentLength = parseInt(maxContentLength);

  return (
      <FormControl size="small">
        <InputLabel id="label">{label}</InputLabel>
        <input id={elemId} className={`${className || ''} hidden`} name={name} value={state}/>
        <Select
          value={state}
          label={label}
          onChange={handleChange}
          defaultValue={value}
          classes={classes}
          autoWidth
          size="small"
          name={name}
          variant="outlined"
          inputProps={inputProps}
          displayEmpty={false}
          disabled={disabled || false}
          sx={{width: 230}}
        >
          <MenuItem value="" sx={{height: 30, minWidth: 200}}></MenuItem>
          {values ? values?.map((item) => {
            return <MenuItem key={item.key} value={item.key} disabled={item.disabled || undefined}
                             sx={{
                               color: theme.palette.text.primary,
                               backgroundColor: theme.palette.background.default
                            }}>{item.value}</MenuItem>
          }) : ''}
        </Select>
      </FormControl>
  );
}

export function FormSelectCtrl({
                                 data,
                                 elemId,
                                 label,
                                 className,
                                 value,
                                 onChange,
                                 inputProps,
                                 name,
                                 required,
                                 classes,
                                 maxContentLength,
                                 disabled,
                                 error,
                                 emptyOpt,
                                 width,
                                 menuMinWidth
                               }) {
  let [state, setState] = React.useState(value);

  const [initialValue, setInitilValue] = useState(value);

  const handleChange = (event) => {
    onChange ? onChange(event) : void 0;

    setState(event.target.value);
  };

  useEffect(() => {
    if (initialValue !== value) {
      setState(value);
      setInitilValue(value);
    }
  }, [value])


  if (maxContentLength)
    maxContentLength = parseInt(maxContentLength);

  return (
      <FormControl size="small">
        <InputLabel id="label">{label}</InputLabel>
        <input id={elemId} className={`${className || ''} hidden`} name={name} value={state}/>
        <Select
          value={state}
          label={label}
          onChange={handleChange}
          classes={classes}
          autoWidth
          required={required || false}
          size="small"
          name={name}
          variant="outlined"
          inputProps={inputProps}
          displayEmpty={false}
          disabled={disabled || false}
          error={error}
          sx={{width: width || 230}}
        >
          {!emptyOpt ?
            <MenuItem value="" sx={{height: 30, minWidth: menuMinWidth || 200}}></MenuItem> : void 0
          }
          {data?.map((item) => {
            return <MenuItem key={item.key} value={item.key}>{item.value}</MenuItem>
          })}
        </Select>
      </FormControl>
  );
}
